wbApp.controller('StudentsAttendanceSummaryCtrl', ['$scope', '$popover', '$timeout', '$translate' ,'attendanceSvc',
function ($scope, $popover, $timeout, $translate, attendanceSvc) {

    var selectedStudent = null;
    var isActive = false;
    var loaded = false;
    $scope.semesters = [];

    $scope.$on('studentSelectionChanged', function (e, data) {
        if (data.student) {
            if (isActive) {
                if (selectedStudent !== data.student || data.refresh) {
                    $scope.semesters = attendanceSvc.getAttendanceSummary(data.student.id);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.semesters.length = 0;
        }
        selectedStudent = data.student;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 3) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedStudent) {
                    $scope.semesters = attendanceSvc.getAttendanceSummary(selectedStudent.id);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });


    $scope.onExcusesClick = function (semester, event) {
        var element = angular.element(document.querySelector('#popover-detail-' + semester.semesterID));

        var myPopover = $popover(element, {
            title: $translate.instant('TXT_COMPENSATION'),
            content: '<table class="table table-condensed">' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_ELIGIBLE_AMENDS') + '</td>' +
                     '        <td>' + semester.eligibleAmends + '</td>' +
                     '    </tr>' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_AMENDS_LEFT') + '</td>' +
                     '        <td>' + semester.remainingAmends + '</td>' +
                     '    </tr>' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_PRE_AMENDS_GRANTED') + '</td>' +
                     '        <td>' + semester.eligiblePreAmends + '</td>' +
                     '    </tr>' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_PRE_AMENDS_LEFT') + '</td>' +
                     '        <td>' + semester.remainingPreAmends + '</td>' +
                     '    </tr>' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_ELIGIBLE_TIME_BOUNDS') + '</td>' +
                     '        <td>' + semester.eligibleTimeBoundAmends + '</td>' +
                     '    </tr>' +
                     '    <tr>' +
                     '        <td>' + $translate.instant('TXT_LBL_TIME_BOUNDS_AMEND') + '</td>' +
                     '        <td>' + semester.remainingTimeBoundAmends + '</td>' +
                     '    </tr>' +
                     '</table>',
            placement: 'top',
            autoClose: true,
            html: true,
            trigger: 'manual',
            container: 'body',
            target: element,
            viewport: 'body',

        });

        myPopover.$promise.then(function () {
            $timeout(function () {
                myPopover.$applyPlacement();
                myPopover.show();
            }, 100);
        });
    }

}]);


